/* Cart drawer: "This order is a gift" (saved as cart attributes: "Gift order" and "Gift message").
   Staff see them under "Additional details" on the order. No app needed. */
(function () {
  if (window.__nvEx) return; window.__nvEx = true;
  function root() { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'); }
  function save(attrs) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }
  // the cart's own code treats every 'change' event inside its form as a quantity edit: keep ours away from it
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[data-nv-gift]')) e.stopPropagation();
  }, true);
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-nv-gift-cb]');
    if (!cb) return;
    var box = cb.closest('[data-nv-gift]'), msg = box.querySelector('[data-nv-gift-msg]');
    box.classList.toggle('is-on', cb.checked);
    msg.hidden = !cb.checked;
    if (cb.checked) { msg.focus(); save({ 'Gift order': 'Yes' }); }
    else { msg.value = ''; save({ 'Gift order': '', 'Gift message': '' }); }
  }, true);
  var t;
  document.addEventListener('input', function (e) {
    var m = e.target.closest && e.target.closest('[data-nv-gift-msg]');
    if (!m) return;
    e.stopPropagation();
    clearTimeout(t);
    t = setTimeout(function () { save({ 'Gift order': 'Yes', 'Gift message': m.value.slice(0, 250) }); }, 600);
  }, true);
})();
